<template>
  <div class="settings-tabs-wrapper">
    <ul class="nav settings-pill-tabs">
      <li class="nav-item">
        <router-link
          v-bind:class="{
            active:
              currentPath.includes('general-settings/bank-details') ||
              currentPath.includes('general-settings/branch-details')
          }"
          class="nav-link pill-tab" to="/general-settings/business-settings">
          <span class="tab-icon-wrap"><i class="ti ti-settings"></i></span>
          <span class="tab-label">General Settings</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          v-bind:class="{
            active:
              currentPath.includes('crm-settings/lead-sources') ||
              currentPath.includes('crm-settings/lead-assignment-rule') ||
              currentPath.includes('crm-settings/project-pipelines'),
          }"
          class="nav-link pill-tab" to="/crm-settings/lead-stages">
          <span class="tab-icon-wrap"><i class="ti ti-adjustments"></i></span>
          <span class="tab-label">CRM Settings</span>
        </router-link>
      </li>

      <!-- <li class="nav-item">
        <router-link
          v-bind:class="{
            active:
              currentPath.includes('system-settings/otp-settings') ||
              currentPath.includes('system-settings/email-settings') ||
              currentPath.includes('system-settings/email-template') ||
              currentPath.includes('system-settings/sms-settings') ||
              currentPath.includes('system-settings/sms-template') ||
              currentPath.includes('system-settings/gdpr') ||
              currentPath.includes('system-settings/maintenance-mode'),
          }"
          class="nav-link pill-tab"
          to="/system-settings/email-settings"
          ><i class="ti ti-server-cog me-2"></i>System Settings</router-link>
      </li> -->

      <li class="nav-item">
        <router-link
          v-bind:class="{
            active:
              currentPath.includes('financial-settings/currencies'),
          }"
          class="nav-link pill-tab" to="/financial-settings/taxes">
          <span class="tab-icon-wrap"><i class="ti ti-settings-dollar"></i></span>
          <span class="tab-label">Financial Settings</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          v-bind:class="{
            active:
              currentPath.includes('app-settings/custom-fields'),
          }"
          class="nav-link pill-tab" to="/app-settings/app-store">
          <span class="tab-icon-wrap"><i class="ti ti-device-ipad-horizontal-cog"></i></span>
          <span class="tab-label">App Settings</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          v-bind:class="{
            active:
              currentPath.includes('document-settings/quotation') ||
              currentPath.includes('document-settings/proforma') ||
              currentPath.includes('document-settings/invoice') ||
              currentPath.includes('document-settings/sales-order') ||
              currentPath.includes('document-settings/sampling') 
          }"
          class="nav-link pill-tab" to="/document-settings/proposal">
          <span class="tab-icon-wrap"><i class="ti ti-file-code-2"></i></span>
          <span class="tab-label">Document Settings</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          v-bind:class="{
            active:
              currentPath.includes('others-settings/roles') ||
              currentPath.includes('others-settings/terms') ||
              currentPath.includes('others-settings/whatsapp-followup-templates') ||
              currentPath.includes('others-settings/brands') ||
              currentPath.includes('others-settings/engineer') ||
              currentPath.includes('others-settings/site-inspectors') ||
              currentPath.includes('others-settings/internal-consumptions')
          }"
          class="nav-link pill-tab" to="/others-settings/configurations">
          <span class="tab-icon-wrap"><i class="ti ti-settings-2"></i></span>
          <span class="tab-label">Other Settings</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPath: this.$route.path,
    };
  },
};
</script>

<style scoped>
/* ── Wrapper ── */
.settings-tabs-wrapper {
  padding: 6px 4px;
}

/* ── Tab List ── */
.settings-pill-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* ── Each Tab Link ── */
.settings-pill-tabs .nav-link.pill-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 8px 12px;
  border-radius: 10px;
  border: 1.5px solid #e5e7eb;
  background: #ffffff;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-decoration: none;
  white-space: nowrap;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.12s ease;
  cursor: pointer;
  position: relative;
}

/* ── Icon Bubble ── */
.tab-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 14px;
  flex-shrink: 0;
  transition:
    background 0.18s ease,
    color 0.18s ease;
}

/* ── Hover ── */
.settings-pill-tabs .nav-link.pill-tab:hover {
  border-color: #c7d2fe;
  background: #f5f3ff;
  color: #4f46e5;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.10);
  transform: translateY(-1px);
}

.settings-pill-tabs .nav-link.pill-tab:hover .tab-icon-wrap {
  background: #e0e7ff;
  color: #4f46e5;
}

/* ── Active ── */
.settings-pill-tabs .nav-link.pill-tab.active,
.settings-pill-tabs .nav-link.pill-tab.router-link-active {
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  border-color: transparent;
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
  transform: translateY(-1px);
  font-weight: 600;
}

.settings-pill-tabs .nav-link.pill-tab.active .tab-icon-wrap,
.settings-pill-tabs .nav-link.pill-tab.router-link-active .tab-icon-wrap {
  background: rgba(255, 255, 255, 0.20);
  color: #ffffff;
}

/* ── Pressed feedback ── */
.settings-pill-tabs .nav-link.pill-tab:active {
  transform: translateY(0px);
}

/* ── Responsive: stack tighter on small screens ── */
@media (max-width: 640px) {
  .settings-pill-tabs {
    gap: 4px;
  }

  .settings-pill-tabs .nav-link.pill-tab {
    padding: 7px 12px 7px 10px;
    font-size: 12px;
  }

  .tab-icon-wrap {
    width: 24px;
    height: 24px;
    font-size: 13px;
  }
}
</style>